// Z73.5 addendum: UK EORI convention -- GB + a 9-12 digit VAT registration number + 000 (a
// trailing branch/division suffix, always 000 for the main registration). Lets the VAT number be
// derived from an EORI (and a mismatch spotted) instead of asking staff to enter both
// independently and trust they agree.
const UK_EORI_PATTERN = /^GB(\d{9,12})000$/

export function deriveVatFromEori(eori: string | null | undefined): string | null {
  if (!eori) return null
  const match = eori.trim().toUpperCase().match(UK_EORI_PATTERN)
  return match ? match[1] : null
}

export function isValidUkEoriFormat(eori: string | null | undefined): boolean {
  if (!eori) return false
  return UK_EORI_PATTERN.test(eori.trim().toUpperCase())
}
